import { render, staticRenderFns } from "./SVGArrowBack.vue?vue&type=template&id=77419b69&scoped=true&"
import script from "./SVGArrowBack.vue?vue&type=script&lang=js&"
export * from "./SVGArrowBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77419b69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77419b69')) {
      api.createRecord('77419b69', component.options)
    } else {
      api.reload('77419b69', component.options)
    }
    module.hot.accept("./SVGArrowBack.vue?vue&type=template&id=77419b69&scoped=true&", function () {
      api.rerender('77419b69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGArrowBack.vue"
export default component.exports